<template>
    <!-- 深蓝-浅蓝   bg-gradient-to-b from-blue-300 to-blue-50-->
    <!-- 无背景  bg-gray-50 -->
    <div class="min-h-screen bg-gradient-to-b from-blue-300 to-blue-50">
        <!-- 顶部导航 -->
        <header class="bg-white/80 backdrop-blur-sm shadow-sm">
            <div class="container mx-auto px-4 py-4 flex justify-between items-center">
                <div class="text-lg font-bold text-gray-800">手机端后台</div>
                <div class="flex items-center space-x-4">
                    <div class="text-sm text-gray-600">欢迎回来，{{ nickName }}</div>
                    <div class="flex space-x-3">
                        <button class="relative p-2 rounded-full hover:bg-gray-100 transition-colors" @click="toHtml(8)">
                            <i class="fa fa-bell text-primary"></i>
                            <span class="absolute top-0 right-0 w-2 h-2 bg-red-500 rounded-full"></span>
                        </button>
                        <button class="p-2 rounded-full hover:bg-gray-100 transition-colors" @click="logouHandler()">
                            <i class="fa fa-sign-out text-red-500"></i>
                        </button>
                    </div>

                </div>
            </div>
        </header>

        <!-- 主要内容 -->
        <main class="container mx-auto px-4 py-6 pb-20">
            <!-- 顶部数据卡片 -->
            <div class="grid grid-cols-2 gap-4 mb-6" v-if="isAgent">
                <div
                    class="bg-white/80 backdrop-blur-sm rounded-xl shadow-sm p-4 transform hover:scale-[1.02] transition-transform">
                    <div class="text-sm text-gray-500 mb-1">总收入</div>
                    <div class="text-2xl font-bold text-blue-600">¥{{ this.baseData.allShouru }}</div>
                    <div class="text-xs text-green-500 mt-1"><i class="fa fa-arrow-up"></i>本月 + {{ this.baseData.monthShouru
                    }}元</div>
                </div>
                <div
                    class="bg-white/80 backdrop-blur-sm rounded-xl shadow-sm p-4 transform hover:scale-[1.02] transition-transform">
                    <div class="text-sm text-gray-500 mb-1">代理总数</div>
                    <div class="text-2xl font-bold text-purple-600">{{ this.baseData.agentTotalCount }}</div>
                    <div class="text-xs text-green-500 mt-1"><i class="fa fa-arrow-up"></i>本月 + {{
                        this.baseData.duibiMonthAdd }}个</div>
                </div>
                <div
                    class="bg-white/80 backdrop-blur-sm rounded-xl shadow-sm p-4 transform hover:scale-[1.02] transition-transform">
                    <div class="text-sm text-gray-500 mb-1">订单总数</div>
                    <div class="text-2xl font-bold text-teal-600">{{ this.baseData.orderMonthCount }}</div>
                    <div class="text-xs text-green-500 mt-1"><i class="fa fa-arrow-up"></i>本月 + {{
                        this.baseData.duibiMonthAddOrder }}%</div>
                </div>
                <div
                    class="bg-white/80 backdrop-blur-sm rounded-xl shadow-sm p-4 transform hover:scale-[1.02] transition-transform">
                    <div class="text-sm text-gray-500 mb-1">卡板总数</div>
                    <div class="text-2xl font-bold text-orange-600">{{ this.baseData.simTotalCount }}</div>
                    <div v-if="this.baseData.biUpNumUse >= 0" class="text-xs text-green-500 mt-1"><i
                            class="fa fa-arrow-up"></i> 在用卡上涨 {{ this.baseData.biUpNumUse }}张 </div>
                    <div v-else class="text-xs text-red-500 mt-1"><i class="fa fa-arrow-down"></i> 在用卡下降 {{
                        this.baseData.biUpNumUse }}张 </div>
                </div>
            </div>
            <div class="grid grid-cols-2 gap-4 mb-6" v-else>
                <div
                    class="bg-white/80 backdrop-blur-sm rounded-xl shadow-sm p-4 transform hover:scale-[1.02] transition-transform">
                    <div class="text-sm text-gray-500 mb-1">套餐充值</div>
                    <div class="text-2xl font-bold text-blue-600">¥{{ money_format(this.baseData.allPayOrderAmount / 100, 2)
                    }}
                    </div>
                    <div class="text-xs text-green-500 mt-1"><i class="fa fa-arrow-up"></i>本月盈利 +{{
                        money_format(this.baseData.simnyyl / 100, 2) }}元</div>
                </div>
                <div
                    class="bg-white/80 backdrop-blur-sm rounded-xl shadow-sm p-4 transform hover:scale-[1.02] transition-transform">
                    <div class="text-sm text-gray-500 mb-1">余额充值</div>
                    <div class="text-2xl font-bold text-purple-600">{{ money_format(this.baseData.yueTotal / 100, 2) }}
                    </div>
                    <div class="text-xs text-green-500 mt-1"><i class="fa fa-arrow-up"></i>本月充值 + {{
                        money_format(this.baseData.nowyue / 100, 2) }}元</div>
                </div>
                <div
                    class="bg-white/80 backdrop-blur-sm rounded-xl shadow-sm p-4 transform hover:scale-[1.02] transition-transform">
                    <div class="text-sm text-gray-500 mb-1">本月盈利</div>
                    <div class="text-2xl font-bold text-teal-600">{{ money_format(this.baseData.simnyyl / 100, 2) }}</div>
                    <div class="text-xs text-green-500 mt-1"><i class="fa fa-arrow-up"></i>今日盈利 + {{
                        money_format(this.baseData.alinowDayYingli / 100, 2) }}元</div>
                </div>
                <div
                    class="bg-white/80 backdrop-blur-sm rounded-xl shadow-sm p-4 transform hover:scale-[1.02] transition-transform">
                    <div class="text-sm text-gray-500 mb-1">卡板总数</div>
                    <div class="text-2xl font-bold text-orange-600">{{ this.baseData.simTotal }}</div>
                    <div class="text-xs text-green-500 mt-1"><i class="fa fa-arrow-up"></i> 在用卡 {{ this.baseData.simTotalyl
                    }}张 </div>
                </div>
            </div>

            <!-- 模块切换 - 优化高亮效果 -->
            <div class="mb-6" v-if="isAgent">
                <div class="bg-white/80 backdrop-blur-sm rounded-xl shadow-sm overflow-hidden">
                    <div class="flex">
                        <button v-for="(module, index) in modules" :key="index" :class="{
                            'bg-primary/10 text-primary font-semibold border-l-4 border-primary': activeModule === index,
                            'text-gray-600 hover:bg-gray-50/80': activeModule !== index
                        }" class="flex-1 py-4 text-center relative z-10 transition-all duration-300"
                            @click="activeModule = index">
                            <i :class="module.icon"
                                :style="{ color: activeModule === index ? module.activeColor : module.inactiveColor }"
                                class="mr-1"></i>
                            {{ module.name }}
                        </button>
                    </div>
                </div>
            </div>
            <div class="mb-6" v-else>
                <div class="bg-white/80 backdrop-blur-sm rounded-xl shadow-sm overflow-hidden">
                    <div class="flex">
                        <button v-for="(module, index) in modulesPc" :key="index" :class="{
                            'bg-primary/10 text-primary font-semibold border-l-4 border-primary': activeModule === index,
                            'text-gray-600 hover:bg-gray-50/80': activeModule !== index
                        }" class="flex-1 py-4 text-center relative z-10 transition-all duration-300"
                            @click="activeModule = index">
                            <i :class="module.icon"
                                :style="{ color: activeModule === index ? module.activeColor : module.inactiveColor }"
                                class="mr-1"></i>
                            {{ module.name }}
                        </button>
                    </div>
                </div>
            </div>

            <!-- 模块内容 - 优化数据展示颜色 -->
            <div class="bg-white/80 backdrop-blur-sm rounded-xl shadow-sm p-4 mb-6">
                <div v-if="activeModule === 0" class="space-y-4">
                    <div class="flex justify-between items-center border-b border-gray-100 pb-2">
                        <div class="font-medium text-gray-800 flex items-center">
                            <i class="fa fa-money text-blue-500 mr-2"></i>财务数据统计详情
                        </div>
                        <div class="text-xs text-gray-500">数据延迟 1-2个小时</div>
                    </div>
                    <div class="space-y-3" v-if="isAgent">
                        <div class="flex justify-between items-center p-2 hover:bg-gray-50/80 rounded-lg transition-colors">
                            <div class="text-gray-600">总收入</div>
                            <div class="font-medium text-blue-600">¥{{ this.baseData.allShouru }} / 元</div>
                        </div>
                        <div class="flex justify-between items-center p-2 hover:bg-gray-50/80 rounded-lg transition-colors">
                            <div class="text-gray-600">本月收入</div>
                            <div class="font-medium text-blue-600">¥{{ this.baseData.monthShouru }} / 元</div>
                        </div>
                        <div class="flex justify-between items-center p-2 hover:bg-gray-50/80 rounded-lg transition-colors">
                            <div class="text-gray-600">今日收入</div>
                            <div class="font-medium text-blue-600">¥{{ this.baseData.dayShouru }} / 元</div>
                        </div>
                        <div class="flex justify-between items-center p-2 hover:bg-gray-50/80 rounded-lg transition-colors">
                            <div class="text-gray-600">未提佣金</div>
                            <div class="font-medium text-orange-600">¥{{ this.baseData.weitiYongjing }} / 元</div>
                        </div>
                        <div class="flex justify-between items-center p-2 hover:bg-gray-50/80 rounded-lg transition-colors">
                            <div class="text-gray-600">剩余预存</div>
                            <div class="font-medium text-green-600">¥{{ this.baseData.shengyuyucun }} / 元</div>
                        </div>
                    </div>
                    <div class="space-y-3" v-else>
                        <div class="flex justify-between items-center p-2 hover:bg-gray-50/80 rounded-lg transition-colors">
                            <div class="text-gray-600">套餐总收入</div>
                            <div class="font-medium text-blue-600">¥{{ money_format(this.baseData.allPayOrderAmount / 100,
                                2) }} / 元</div>
                        </div>
                        <div class="flex justify-between items-center p-2 hover:bg-gray-50/80 rounded-lg transition-colors">
                            <div class="text-gray-600">上月盈利</div>
                            <div class="font-medium text-blue-600">¥{{ money_format(this.baseData.simuypyl / 100, 2) }} / 元
                            </div>
                        </div>
                        <div class="flex justify-between items-center p-2 hover:bg-gray-50/80 rounded-lg transition-colors">
                            <div class="text-gray-600">本月盈利</div>
                            <div class="font-medium text-blue-600">¥{{ money_format(this.baseData.simnyyl / 100, 2) }} / 元
                            </div>
                        </div>
                        <div class="flex justify-between items-center p-2 hover:bg-gray-50/80 rounded-lg transition-colors">
                            <div class="text-gray-600">昨日盈利</div>
                            <div class="font-medium text-orange-600">¥{{ money_format(this.baseData.simyeyl / 100, 2) }} / 元
                            </div>
                        </div>
                        <div class="flex justify-between items-center p-2 hover:bg-gray-50/80 rounded-lg transition-colors">
                            <div class="text-gray-600">今日盈利</div>
                            <div class="font-medium text-green-600">¥{{ money_format(this.baseData.alinowDayYingli / 100, 2)
                            }} / 元</div>
                        </div>
                    </div>
                </div>

                <div v-if="activeModule === 1" class="space-y-4">
                    <div class="flex justify-between items-center border-b border-gray-100 pb-2">
                        <div class="font-medium text-gray-800 flex items-center">
                            <i class="fa fa-credit-card text-purple-500 mr-2"></i>卡板数据统计详情
                        </div>
                        <div class="text-xs text-gray-500">数据延迟 40-60分钟</div>
                    </div>
                    <div class="space-y-3" v-if="isAgent">
                        <div class="flex justify-between items-center p-2 hover:bg-gray-50/80 rounded-lg transition-colors">
                            <div class="text-gray-600">卡板总数</div>
                            <div class="font-medium text-purple-600">{{ this.baseData.simTotalCount }} / 张</div>
                        </div>
                        <div class="flex justify-between items-center p-2 hover:bg-gray-50/80 rounded-lg transition-colors">
                            <div class="text-gray-600">激活卡总数</div>
                            <div class="font-medium text-purple-600">{{ this.baseData.simAlreadySold }} / 张</div>
                        </div>
                        <div class="flex justify-between items-center p-2 hover:bg-gray-50/80 rounded-lg transition-colors">
                            <div class="text-gray-600">在用卡总数</div>
                            <div class="font-medium text-purple-600">{{ this.baseData.simNotSold }} / 张</div>
                        </div>
                    </div>
                    <div class="space-y-3" v-else>
                        <div class="flex justify-between items-center p-2 hover:bg-gray-50/80 rounded-lg transition-colors">
                            <div class="text-gray-600">卡板总数</div>
                            <div class="font-medium text-purple-600">{{ this.baseData.simTotal }} / 张</div>
                        </div>
                        <div class="flex justify-between items-center p-2 hover:bg-gray-50/80 rounded-lg transition-colors">
                            <div class="text-gray-600">在用卡总数</div>
                            <div class="font-medium text-purple-600">{{ this.baseData.simTotalyl }} / 张</div>
                        </div>
                        <div class="flex justify-between items-center p-2 hover:bg-gray-50/80 rounded-lg transition-colors">
                            <div class="text-gray-600">已激活状态</div>
                            <div class="font-medium text-green-600">{{ this.baseData.yijihuoSim }} / 张</div>
                        </div>
                        <div class="flex justify-between items-center p-2 hover:bg-gray-50/80 rounded-lg transition-colors">
                            <div class="text-gray-600">停机状态</div>
                            <div class="font-medium text-red-600">{{ this.baseData.tingjiSim }} / 张</div>
                        </div>
                        <div class="flex justify-between items-center p-2 hover:bg-gray-50/80 rounded-lg transition-colors">
                            <div class="text-gray-600">库存状态</div>
                            <div class="font-medium text-purple-600">{{ this.baseData.kucunSim }} / 张</div>
                        </div>
                        <div class="flex justify-between items-center p-2 hover:bg-gray-50/80 rounded-lg transition-colors">
                            <div class="text-gray-600">待激活状态</div>
                            <div class="font-medium text-purple-600">{{ this.baseData.daijihuoSim }} / 张</div>
                        </div>
                    </div>
                </div>

                <div v-if="activeModule === 2" class="space-y-4">
                    <div class="flex justify-between items-center border-b border-gray-100 pb-2">
                        <div class="font-medium text-gray-800 flex items-center" v-if="isAgent">
                            <i class="fa fa-shopping-cart text-teal-500 mr-2"></i>订单数据详情
                        </div>
                        <div class="font-medium text-gray-800 flex items-center" v-else>
                            <i class="fa fa-shopping-cart text-teal-500 mr-2"></i>余额数据详情
                        </div>
                        <div class="text-xs text-gray-500">数据延迟 10-20分钟</div>
                    </div>
                    <div class="space-y-3" v-if="isAgent">
                        <div class="flex justify-between items-center p-2 hover:bg-gray-50/80 rounded-lg transition-colors">
                            <div class="text-gray-600">订单总数</div>
                            <div class="font-medium text-teal-600">{{ this.baseData.orderMonthCount }} / 单</div>
                        </div>
                        <div class="flex justify-between items-center p-2 hover:bg-gray-50/80 rounded-lg transition-colors">
                            <div class="text-gray-600">本月订单</div>
                            <div class="font-medium text-teal-600">{{ this.baseData.backOrderMonthCount }} / 单</div>
                        </div>
                        <div class="flex justify-between items-center p-2 hover:bg-gray-50/80 rounded-lg transition-colors">
                            <div class="text-gray-600">今日订单</div>
                            <div class="font-medium text-teal-600">{{ this.baseData.orderUpMonthCount }} / 单</div>
                        </div>
                    </div>
                    <div class="space-y-3" v-else>
                        <div class="flex justify-between items-center p-2 hover:bg-gray-50/80 rounded-lg transition-colors">
                            <div class="text-gray-600">余额充值总额</div>
                            <div class="font-medium text-teal-600">{{ money_format(this.baseData.yueTotal / 100, 2) }} / 元
                            </div>
                        </div>
                        <div class="flex justify-between items-center p-2 hover:bg-gray-50/80 rounded-lg transition-colors">
                            <div class="text-gray-600">上月充值总额</div>
                            <div class="font-medium text-teal-600">{{ money_format(this.baseData.upyue / 100, 2) }} / 元
                            </div>
                        </div>
                        <div class="flex justify-between items-center p-2 hover:bg-gray-50/80 rounded-lg transition-colors">
                            <div class="text-gray-600">本月充值总额</div>
                            <div class="font-medium text-teal-600">{{ money_format(this.baseData.nowyue / 100, 2) }} / 元
                            </div>
                        </div>
                        <div class="flex justify-between items-center p-2 hover:bg-gray-50/80 rounded-lg transition-colors">
                            <div class="text-gray-600">用户未使用余额</div>
                            <div class="font-medium text-purple-600">{{ money_format(this.baseData.yueRemain / 100, 2) }} /
                                元</div>
                        </div>
                    </div>
                </div>

                <div v-if="activeModule === 3" class="space-y-4">
                    <div class="flex justify-between items-center border-b border-gray-100 pb-2">
                        <div class="font-medium text-gray-800 flex items-center">
                            <i class="fa fa-users text-indigo-500 mr-2"></i>代理数据统计详情
                        </div>
                        <div class="text-xs text-gray-500">数据延迟 5-10分钟</div>
                    </div>
                    <div class="space-y-3">
                        <div class="flex justify-between items-center p-2 hover:bg-gray-50/80 rounded-lg transition-colors">
                            <div class="text-gray-600">代理总数</div>
                            <div class="font-medium text-indigo-600">{{ this.baseData.agentTotalCount }} / 个</div>
                        </div>
                        <div class="flex justify-between items-center p-2 hover:bg-gray-50/80 rounded-lg transition-colors">
                            <div class="text-gray-600">直属代理</div>
                            <div class="font-medium text-indigo-600">{{ this.baseData.agentAlreadyInvest }} / 个</div>
                        </div>
                        <div class="flex justify-between items-center p-2 hover:bg-gray-50/80 rounded-lg transition-colors">
                            <div class="text-gray-600">今日新增代理</div>
                            <div class="font-medium text-green-600">{{ this.baseData.agentNotInvest }} / 个</div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 基础操作模块 -->
            <div class="grid grid-cols-3 gap-3 mb-6">
                <button
                    class="bg-white/80 backdrop-blur-sm rounded-xl shadow-sm p-4 flex flex-col items-center transform hover:scale-[1.03] transition-transform"
                    @click="toHtml(1)">
                    <div class="w-10 h-10 rounded-full bg-blue-100/80 flex items-center justify-center mb-2">
                        <i class="fa fa-credit-card text-blue-500"></i>
                    </div>
                    <div class="text-xs text-gray-700">卡板查询</div>
                </button>
                <button
                    class="bg-white/80 backdrop-blur-sm rounded-xl shadow-sm p-4 flex flex-col items-center transform hover:scale-[1.03] transition-transform"
                    @click="toHtml(10)">
                    <div class="w-10 h-10 rounded-full bg-indigo-100/80 flex items-center justify-center mb-2">
                        <i class="fa fa-money text-indigo-500"></i>
                    </div>
                    <div class="text-xs text-gray-700">卡板充值</div>
                </button>
                <button
                    class="bg-white/80 backdrop-blur-sm rounded-xl shadow-sm p-4 flex flex-col items-center transform hover:scale-[1.03] transition-transform"
                    @click="toHtml(11)">
                    <div class="w-10 h-10 rounded-full bg-green-100/80 flex items-center justify-center mb-2">
                       <i class="fa fa-exchange text-green-500 text-lg"></i>
                    </div>
                    <div class="text-xs text-gray-700">回收/分销</div>
                </button>

                <button
                    class="bg-white/80 backdrop-blur-sm rounded-xl shadow-sm p-4 flex flex-col items-center transform hover:scale-[1.03] transition-transform"
                    @click="toHtml(2)">
                    <div class="w-10 h-10 rounded-full bg-green-100/80 flex items-center justify-center mb-2">
                        <i class="fa fa-shopping-cart text-green-500"></i>
                    </div>
                    <div class="text-xs text-gray-700">订单管理</div>
                </button>
                <button
                    class="bg-white/80 backdrop-blur-sm rounded-xl shadow-sm p-4 flex flex-col items-center transform hover:scale-[1.03] transition-transform"
                    @click="toHtml(3)">
                    <div class="w-10 h-10 rounded-full bg-purple-100/80 flex items-center justify-center mb-2">
                        <i class="fa fa-th-large text-purple-500"></i>
                    </div>
                    <div class="text-xs text-gray-700">套餐类别</div>
                </button>
                <button
                    class="bg-white/80 backdrop-blur-sm rounded-xl shadow-sm p-4 flex flex-col items-center transform hover:scale-[1.03] transition-transform"
                    @click="toHtml(4)">
                    <div class="w-10 h-10 rounded-full bg-yellow-100/80 flex items-center justify-center mb-2">
                        <i class="fa fa-share-alt text-yellow-500"></i>
                    </div>
                    <div class="text-xs text-gray-700">套餐分销</div>
                </button>
                <button
                    class="bg-white/80 backdrop-blur-sm rounded-xl shadow-sm p-4 flex flex-col items-center transform hover:scale-[1.03] transition-transform"
                    @click="toHtml(5)">
                    <div class="w-10 h-10 rounded-full bg-red-100/80 flex items-center justify-center mb-2">
                        <i class="fa fa-users text-red-500"></i>
                    </div>
                    <div class="text-xs text-gray-700">客户管理</div>
                </button>

                <button
                    class="bg-white/80 backdrop-blur-sm rounded-xl shadow-sm p-4 flex flex-col items-center transform hover:scale-[1.03] transition-transform"
                    @click="toHtml(7)">
                    <div class="w-10 h-10 rounded-full bg-pink-100/80 flex items-center justify-center mb-2">
                        <i class="fa fa-list text-pink-500"></i>
                    </div>
                    <div class="text-xs text-gray-700">买卡列表</div>
                </button>
                <button
                    class="bg-white/80 backdrop-blur-sm rounded-xl shadow-sm p-4 flex flex-col items-center transform hover:scale-[1.03] transition-transform"
                    @click="toHtml(8)">
                    <div class="w-10 h-10 rounded-full bg-teal-100/80 flex items-center justify-center mb-2">
                        <i class="fa fa-bullhorn text-teal-500"></i>
                    </div>
                    <div class="text-xs text-gray-700">公告</div>
                </button>
                <button
                    class="bg-white/80 backdrop-blur-sm rounded-xl shadow-sm p-4 flex flex-col items-center transform hover:scale-[1.03] transition-transform"
                    @click="toHtml(6)">
                    <div class="w-10 h-10 rounded-full bg-orange-100/80 flex items-center justify-center mb-2">
                        <i class="fa fa-history text-orange-500"></i>
                    </div>
                    <div class="text-xs text-gray-700">佣金提现</div>
                </button>

            </div>
        </main>

    </div>
</template>
  
<script>
import { wxRequest } from '@/api/agent.js';
import { Toast, Dialog } from 'vant'
var echarts = require('echarts/lib/echarts');// 引入 ECharts 主模块
require('echarts/lib/chart/line');// 引入折线图
export default {
    name: 'App',
    data() {
        return {
            isAgent: false,
            baseData: {},
            nickName: localStorage.getItem('nickName'),
            notify: {
                id: '',
                title: '',
                content: '',
            },
            activeModule: 0,
            alreadyRead: false,

            modules: [
                { name: '财政', icon: 'fa fa-money', activeColor: '#3B82F6', inactiveColor: '#94A3B8' },
                { name: '卡板', icon: 'fa fa-credit-card', activeColor: '#8B5CF6', inactiveColor: '#94A3B8' },
                { name: '订单', icon: 'fa fa-shopping-cart', activeColor: '#14B8A6', inactiveColor: '#94A3B8' },
                { name: '代理', icon: 'fa fa-users', activeColor: '#6366F1', inactiveColor: '#94A3B8' }
            ],
            modulesPc: [
                { name: '盈利', icon: 'fa fa-money', activeColor: '#3B82F6', inactiveColor: '#94A3B8' },
                { name: '卡板', icon: 'fa fa-credit-card', activeColor: '#8B5CF6', inactiveColor: '#94A3B8' },
                { name: '余额', icon: 'fa fa-shopping-cart', activeColor: '#14B8A6', inactiveColor: '#94A3B8' },
            ]
        };
    },
    created() {
        this.getAgentBaseDataHandler();
        this.getNotifyListHandler();
    },
    methods: {
        getAgentBaseDataHandler() {
            var data = {
                account: localStorage.getItem('accountName')
            }
            wxRequest("agentCount/info/new", data, "get").then(res => {
                if (res.data.code == 200) {
                     if (res.data.data.monthShouru !== undefined && res.data.data.monthShouru >= 0) {
                        this.isAgent = true;
                    }
                    this.baseData = res.data.data;
                } else {
                    this.$messagebox.alert(res.data.message);
                }
            })
        },

        getNotifyListHandler() {
            var data = {
                accountName: localStorage.getItem('accountName')
            }
            wxRequest("agentNotice/new/notice", data, "post").then(res => {
                if (res.data.code == 200) {
                    if (res.data.data) {
                        this.notify = res.data.data;
                        Dialog.confirm({
                            title: this.notify.title,
                            message: this.notify.content,
                            confirmButtonText: "已阅读",
                            cancelButtonText: "取消",
                        }).then(() => {
                            var data = {
                                id: this.notify.id,
                                accountName: localStorage.getItem('accountName')
                            }
                            wxRequest("agentNotice/udapte", data, "post").then(res => {
                                this.alreadyRead = true;
                            })
                        }).catch(() => { });
                    }
                }
            })
        },
        toHtml(num) {
            if (num == 1) {
                this.$router.push('/agent/updateCard')
            } else if (num == 2) {
                this.$router.push('/agent/myorder')
            } else if (num == 3) {
                this.$router.push('/agent/pkg')
            } else if (num == 4) {
                this.$router.push('/agent/card2')
            } else if (num == 5) {
                this.$router.push('/agent/addUser')
            } else if (num == 6) {
                this.$router.push('/agent/withdrawal')
            } else if (num == 7) {
                this.$router.push('/agent/buysim')
            } else if (num == 8) {
                this.$router.push('/agent/notify')
            } else if (num == 9) {
                this.$router.push('/agent/distributRecord')
            } else if (num == 10) {
                this.$router.push('/agent/inentSim')
            } else if (num == 11) {
                this.$router.push('/agent/card')
            }
        },
        logouHandler() {
            this.$router.push('/agent/login');
            localStorage.removeItem('token');
        },
    }
}
</script>
  
<style scoped>
:root {
    --primary: #3B82F6;
}


/* 添加自定义过渡动画 */
.transition-all {
    transition: all 0.3s ease;
}

/* 为模块内容添加微动画 */
.module-content-enter-active,
.module-content-leave-active {
    transition: opacity 0.3s, transform 0.3s;
}

.module-content-enter,
.module-content-leave-to {
    opacity: 0;
    transform: translateY(10px);
}
</style>